import React from 'react';
import PropTypes from 'prop-types';
import withStyles from '@mui/styles/withStyles';
import classNames from 'classnames';
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import TextField from '@mui/material/TextField';
import Card from '@mui/material/Card';
import AddFraisRetourExcluDialog from './AddFraisRetourExcluDialog';
import DeleteFraisRetourExcluDialog from './DeleteFraisRetourExcluDialog';
import { green } from '@mui/material/colors';

const styles = theme => ({
    root: {
        margin: 0,
        padding: 0
    },
    table: {
        //minWidth: 700
    },
    buttonProgress: {
        color: green[500],
        position: 'absolute',
        top: '50%',
        left: '50%',
        marginTop: -12,
        marginLeft: -12
    },
    link: theme.style.link,
    administrationHeaderContainer: {
        display: 'flex',
        width: '100%'
    },
    administrationHeaderItemLeft: {
        flex: '1 1 auto'
    },
    administrationHeaderItemRight: {
        flex: '0 1 auto'
    },
    deleting: {
        background: 'red'
    },
    nowrapCell: {
        whiteSpace: 'nowrap'
    },
    paper: {
        padding: theme.spacing(2),
        marginBottom: theme.spacing(3)
    },
    actionContainer: {
        display: 'flex',
        width: '100%',
        flexDirection: 'row-reverse',
        marginBottom: theme.spacing(3)
    }
});

class AdministrationFraisRetourExclus extends React.Component {
    render() {
        let {
            classes, fraisRetourExclus, pctJokerFraisRetour, niveaux,
            addFraisRetourExcluDialogOpen, onOpenAddDialog, onCloseAddDialog, addFraisRetourExclu,
            deleteFraisRetourExcluDialogOpen, onOpenDeleteDialog, onCloseDeleteDialog, deleteFraisRetourExclu, fraisRetourExcluToDelete,
            onPctJokerFraisRetourChange, patchPctJokerFraisRetour
        } = this.props;

        return (
            <React.Fragment>
                {addFraisRetourExcluDialogOpen && <AddFraisRetourExcluDialog niveaux={niveaux} onClose={onCloseAddDialog} onClickSave={addFraisRetourExclu} />}
                {deleteFraisRetourExcluDialogOpen && <DeleteFraisRetourExcluDialog niveaux={niveaux} onClose={onCloseDeleteDialog} onClickDelete={deleteFraisRetourExclu} fraisRetourExclu={fraisRetourExcluToDelete} />}

                <Card className={classNames(classes.paper)}>
                    <div className={classes.administrationHeaderContainer}>
                        <Typography gutterBottom variant="h5" className={classes.administrationHeaderItemLeft}>
                            Administration du pourcentage "joker" frais de retour
                    </Typography>
                    </div>

                    <TextField
                        className={classes.marginTop}
                        name='pctJokerFraisRetour'
                        label="Avoir joker"
                        value={pctJokerFraisRetour}
                        onChange={e => onPctJokerFraisRetourChange(e.target.value)}
                    />

                    <div className={classes.actionContainer} >
                        <Button
                            className={classes.buttonControl}
                            disabled={false}
                            onClick={patchPctJokerFraisRetour}
                            variant="contained"
                            color="secondary"
                        >Enregistrer
                        </Button>
                    </div>
                </Card>

                <Card className={classNames(classes.paper)}>
                    <div className={classes.administrationHeaderContainer}>
                        <Typography gutterBottom variant="h5" className={classes.administrationHeaderItemLeft}>
                            Administration des exclusions pour les frais de retour
                    </Typography>
                        <Button className={classes.administrationHeaderItemRight} onClick={onOpenAddDialog}>Nouvelle</Button>
                    </div>

                    <Paper className={classes.root}>
                        <Table className={classes.table} size='small'>
                            <TableHead>
                                <TableRow>
                                    <TableCell>Niveau</TableCell>
                                    <TableCell>Code</TableCell>
                                    <TableCell>{`Profil\xa0PO`}</TableCell>
                                    <TableCell>Actions</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {fraisRetourExclus.map(fraisRetourExclu => {
                                    let niveau = niveaux.find(n => n.id === fraisRetourExclu.niveau);
                                    return (
                                        <TableRow key={fraisRetourExclu.id} className={fraisRetourExcluToDelete && fraisRetourExcluToDelete.id === fraisRetourExclu.id ? classes.deleting : ''}
                                            hover
                                        >
                                            <TableCell>{niveau.libelle}</TableCell>
                                            <TableCell>{fraisRetourExclu.code}</TableCell>
                                            <TableCell>{fraisRetourExclu.profilPO}</TableCell>
                                            <TableCell>
                                                <Button onClick={e => onOpenDeleteDialog(fraisRetourExclu.id)}>Supprimer</Button>
                                            </TableCell>
                                        </TableRow>
                                    );
                                })}
                            </TableBody>
                        </Table>
                    </Paper>
                </Card>
            </React.Fragment>
        );
    }
}

AdministrationFraisRetourExclus.propTypes = {
    classes: PropTypes.object.isRequired,
    niveaux: PropTypes.array.isRequired,
    fraisRetourExclus: PropTypes.array.isRequired
};

export default withStyles(styles)(AdministrationFraisRetourExclus);